var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "ul",
        { staticClass: "trademark-category-ul" },
        _vm._l(_vm.trademarkCategoryList, function(item, index) {
          return _c(
            "li",
            { key: index },
            [
              _c("div", { staticClass: "trademark-category" }, [
                item.category1Name
                  ? _c(
                      "span",
                      {
                        on: {
                          click: function($event) {
                            return _vm.showDrawerCategory(index, 1)
                          }
                        }
                      },
                      [_vm._v("编辑")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                item.category1Name
                  ? _c(
                      "p",
                      {
                        on: {
                          click: function($event) {
                            return _vm.showDrawerCategory(index, 1)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(item.category1Num) +
                            " " +
                            _vm._s(item.category1Name) +
                            "\n        "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !item.category1Name
                  ? _c(
                      "span",
                      [
                        _c("a-icon", {
                          attrs: { type: "right" },
                          on: {
                            click: function($event) {
                              return _vm.showDrawerCategory(index, 1)
                            }
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !item.category1Name
                  ? _c(
                      "p",
                      {
                        staticClass: "category-placeholder",
                        on: {
                          click: function($event) {
                            return _vm.showDrawerCategory(index, 1)
                          }
                        }
                      },
                      [_vm._v("\n          请选择大类\n        ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                item.listTrademarkCategory2 &&
                item.listTrademarkCategory2.length &&
                _vm.existSubclass
                  ? _c(
                      "b",
                      {
                        on: {
                          click: function($event) {
                            return _vm.showDrawerCategory(index, 2)
                          }
                        }
                      },
                      [_vm._v("编辑小类")]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              item.listTrademarkCategory2 &&
              item.listTrademarkCategory2.length &&
              _vm.existSubclass
                ? _c("a-table", {
                    staticClass: "trademark-subcategory-table",
                    attrs: {
                      scroll: { y: 220 },
                      rowKey: "category2Num",
                      pagination: false,
                      columns: _vm.subCategoryColumns,
                      "data-source": item.listTrademarkCategory2
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "index",
                          fn: function(text, record, index) {
                            return [_c("span", [_vm._v(_vm._s(index + 1))])]
                          }
                        },
                        {
                          key: "categoryName",
                          fn: function(text, record) {
                            return [
                              _c("span", [_vm._v(_vm._s(record.category2Name))])
                            ]
                          }
                        },
                        {
                          key: "categoryNameEn",
                          fn: function(text, record) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(record.category2NameEn))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.existSubclass
                ? _c(
                    "div",
                    [
                      _vm._m(0, true),
                      _vm._v(" "),
                      _c("Input", {
                        staticClass: "textareaubclass",
                        attrs: {
                          type: "textarea",
                          rows: 3,
                          autosize: { minRows: 4, maxRows: 7 },
                          placeholder: _vm.placeholder
                        },
                        model: {
                          value:
                            _vm.trademarkCategoryList[index].textareaubclass,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.trademarkCategoryList[index],
                              "textareaubclass",
                              $$v
                            )
                          },
                          expression:
                            "trademarkCategoryList[index].textareaubclass"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              item.riskClassifyList.length > 0 &&
              _vm.serviceInfo.countryCode == "US"
                ? _c(
                    "div",
                    { staticClass: "risk-box" },
                    [
                      _c(
                        "p",
                        { staticClass: "item-label red-tip from risk-title" },
                        [_vm._v("含有风险小类，需指定关键词")]
                      ),
                      _vm._v(" "),
                      _vm._m(1, true),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticStyle: {
                            color: "#ED7B2F",
                            "font-size": "14px",
                            margin: "10px 0 0 0"
                          }
                        },
                        [_vm._v("风险小类被驳回机率较大，请慎重选择")]
                      ),
                      _vm._v(" "),
                      _c("a-table", {
                        staticClass: "trademark-subcategory-table",
                        attrs: {
                          rowKey: "category2NameEn",
                          pagination: false,
                          columns: _vm.riskClassCloumns,
                          "data-source": item.riskClassifyList
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "categoryNameEn",
                              fn: function(text, record) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(record.category2NameEn))
                                  ])
                                ]
                              }
                            },
                            {
                              key: "categoryKeyword",
                              fn: function(text, record) {
                                return [
                                  _c("a-input", {
                                    staticClass: "category-keyword",
                                    attrs: {
                                      placeholder:
                                        "请从风险小类{ }内指定一个关键词"
                                    },
                                    model: {
                                      value: record.keyword,
                                      callback: function($$v) {
                                        _vm.$set(record, "keyword", $$v)
                                      },
                                      expression: "record.keyword"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "a-drawer",
        {
          attrs: {
            placement: "right",
            visible: _vm.categoryVisible,
            maskClosable: false,
            width: 720
          },
          on: { close: _vm.onClose }
        },
        [
          _c("template", { slot: "title" }, [
            _vm.stepIndex == 1
              ? _c("span", [_vm._v("选择商标大类")])
              : _c("span", [
                  _vm._v("选择「"),
                  _c("a", { staticClass: "a-text-color" }, [
                    _vm._v(
                      _vm._s(
                        _vm.categoryCurrent[0].categoryName ||
                          _vm.categoryCurrent[0].category1Name
                      )
                    )
                  ]),
                  _vm._v("」商标小类")
                ])
          ]),
          _vm._v(" "),
          _vm.stepIndex == 1
            ? _c("a-alert", {
                attrs: {
                  message:
                    "不确定要选择哪个分类？可尝试搜索竞争对手的商标，然后，查看它的商标详情中申请的分类。如果仍不确定要选择哪个分类，请咨询我们的客服人员。",
                  type: "info",
                  "show-icon": ""
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.stepIndex == 1
            ? _c(
                "ul",
                { staticClass: "trademark-category-list" },
                _vm._l(_vm.firstClassList, function(item) {
                  return _c(
                    "li",
                    {
                      key: item.categoryNum,
                      class: { current: item.check },
                      on: {
                        click: function($event) {
                          return _vm.categoryHandle(item)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(item.categoryNum) +
                          " " +
                          _vm._s(item.categoryName) +
                          "\n      "
                      )
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.stepIndex == 2
            ? _c(
                "dl",
                {
                  staticClass:
                    "trademark-subcategory trademark-subcategory-search-wrap"
                },
                [
                  _c(
                    "dt",
                    [
                      _c("a-input-search", {
                        staticClass: "trademark-subcategory-search",
                        attrs: {
                          placeholder:
                            "请输入产品关键词小类中文或英文名称检索小类"
                        },
                        on: {
                          search: function(val) {
                            return _vm.onSearch(val)
                          }
                        },
                        model: {
                          value: _vm.searchtext,
                          callback: function($$v) {
                            _vm.searchtext = $$v
                          },
                          expression: "searchtext"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.subCategoryList.length
                    ? _c(
                        "dd",
                        { staticClass: "sub-category-list" },
                        [
                          _c(
                            "div",
                            { staticClass: "sub-category-table-wrap" },
                            [
                              _c(
                                "table",
                                { staticClass: "sub-category-table" },
                                [
                                  _c("tr", [
                                    _c("th", { attrs: { width: "60" } }, [
                                      _vm._v("选择")
                                    ]),
                                    _vm._v(" "),
                                    _c("th", [_vm._v("中文名称")]),
                                    _vm._v(" "),
                                    _c("th", [_vm._v("英文")]),
                                    _vm._v(" "),
                                    _vm.serviceInfo.countryCode === "JP"
                                      ? _c("th", [_vm._v("日文")])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.serviceInfo.countryCode === "JP"
                                      ? _c("th", [_vm._v("群组")])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.serviceInfo.countryCode === "KR"
                                      ? _c("th", [_vm._v("韩文")])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.serviceInfo.countryCode === "DE"
                                      ? _c("th", [_vm._v("德文")])
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.subCategoryList, function(item) {
                                    return _c("tr", { key: item.id }, [
                                      _c(
                                        "td",
                                        [
                                          _c("a-checkbox", {
                                            on: {
                                              change: function(e) {
                                                return _vm.changeSubCategory(
                                                  e,
                                                  item
                                                )
                                              }
                                            },
                                            model: {
                                              value: item.check,
                                              callback: function($$v) {
                                                _vm.$set(item, "check", $$v)
                                              },
                                              expression: "item.check"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            item.categoryName ||
                                              item.category2Name
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm.serviceInfo.countryCode !== "CN"
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  item.categoryNameEn ||
                                                    item.category2NameEn
                                                )
                                              )
                                            ])
                                          : _vm._e()
                                      ]),
                                      _vm._v(" "),
                                      _vm.serviceInfo.countryCode === "JP"
                                        ? _c("td", [
                                            _vm._v(_vm._s(item.categoryNameJp))
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.serviceInfo.countryCode === "JP"
                                        ? _c("td", [
                                            _vm._v(_vm._s(item.similarGroup))
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      ["KR", "DE"].includes(
                                        _vm.serviceInfo.countryCode
                                      )
                                        ? _c("th", [
                                            _vm._v(
                                              _vm._s(item.categoryNameMore)
                                            )
                                          ])
                                        : _vm._e()
                                    ])
                                  })
                                ],
                                2
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("a-pagination", {
                            attrs: {
                              pageSize: _vm.pageInfo.limit,
                              total: _vm.pageInfo.total,
                              "show-less-items": ""
                            },
                            on: { change: _vm.paginationChange },
                            model: {
                              value: _vm.pageInfo.page,
                              callback: function($$v) {
                                _vm.$set(_vm.pageInfo, "page", $$v)
                              },
                              expression: "pageInfo.page"
                            }
                          })
                        ],
                        1
                      )
                    : _c(
                        "dd",
                        { staticClass: "sub-category-list" },
                        [_c("a-empty", { attrs: { image: _vm.simpleImage } })],
                        1
                      )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.stepIndex == 2
            ? _c("dl", { staticClass: "trademark-subcategory" }, [
                _c(
                  "dt",
                  [
                    _c(
                      "a-popconfirm",
                      {
                        attrs: {
                          placement: "topRight",
                          title: "确定清空所有选中的商标类别吗?",
                          "ok-text": "确定",
                          "cancel-text": "取消"
                        },
                        on: { confirm: _vm.subcategoryEmptyOk }
                      },
                      [
                        _c("span", { staticClass: "subcategory-empty" }, [
                          _vm._v("清空")
                        ])
                      ]
                    ),
                    _vm._v(
                      "已选择 " +
                        _vm._s(_vm.subCategoryListCurr.length) +
                        "\n      "
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.subCategoryListCurr.length
                  ? _c("dd", { staticClass: "sub-category-list" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "sub-category-table-wrap sub-category-table-wrap-current"
                        },
                        [
                          _c(
                            "table",
                            { staticClass: "sub-category-table" },
                            _vm._l(_vm.subCategoryListCurr, function(item) {
                              return _c("tr", { key: item.id }, [
                                _c(
                                  "td",
                                  { attrs: { width: "60" } },
                                  [
                                    _c("a-checkbox", {
                                      attrs: { checked: true },
                                      on: {
                                        change: function(e) {
                                          return _vm.changeSubCategory(e, item)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      item.categoryName || item.category2Name
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm.serviceInfo.countryCode !== "CN"
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            item.categoryNameEn ||
                                              item.category2NameEn
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _vm.serviceInfo.countryCode === "JP"
                                  ? _c("td", [
                                      _vm._v(_vm._s(item.categoryNameJp))
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.serviceInfo.countryCode === "JP"
                                  ? _c("td", [
                                      _vm._v(_vm._s(item.similarGroup))
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                ["KR", "DE"].includes(
                                  _vm.serviceInfo.countryCode
                                )
                                  ? _c("th", [
                                      _vm._v(_vm._s(item.categoryNameMore))
                                    ])
                                  : _vm._e()
                              ])
                            }),
                            0
                          )
                        ]
                      )
                    ])
                  : _c(
                      "dd",
                      { staticClass: "sub-category-list" },
                      [_c("a-empty", { attrs: { image: _vm.simpleImage } })],
                      1
                    )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "trademark-category-footer" },
            [
              _vm.existSubclass
                ? [
                    _vm.stepIndex == 1
                      ? _c(
                          "a-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.categoryNext(2)
                              }
                            }
                          },
                          [_vm._v("\n          下一步\n        ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.stepIndex == 2
                      ? _c(
                          "a-button",
                          {
                            style: { marginRight: "8px" },
                            on: {
                              click: function($event) {
                                return _vm.categoryNext(1)
                              }
                            }
                          },
                          [_vm._v("\n          上一步\n        ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.stepIndex == 2
                      ? _c(
                          "a-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.trademarkCategoryOk }
                          },
                          [_vm._v("\n          提交\n        ")]
                        )
                      : _vm._e()
                  ]
                : _c(
                    "a-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.trademarkCategoryOk }
                    },
                    [_vm._v("\n        提交\n      ")]
                  )
            ],
            2
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticClass: "item-label red-tip from" }, [
        _vm._v("商标小类名称：")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tip-box" }, [
      _c("img", {
        attrs: { src: require("@/assets/images/infoDetail/tip.svg"), alt: "" }
      }),
      _vm._v(" "),
      _c("p", [
        _c("span", { staticClass: "color333" }, [_vm._v("风险小类：")]),
        _vm._v(
          "美国遵循国际尼斯分类，对其申请的商品/服务项目要求具体细化。例如：“计算机周边设备”该项商品在美国是"
        ),
        _c("br"),
        _vm._v(
          "不能被接受，原因是范围太宽泛，需要进一步细化到“键盘、鼠标、扫描仪”等。\n          "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3aa1baa4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3aa1baa4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DynamicForm/TrademarkClassification/index.vue
// module id = null
// module chunks = 